import { render, staticRenderFns } from "./RecentCriteria.vue?vue&type=template&id=d67713e0"
import script from "./RecentCriteria.vue?vue&type=script&lang=js"
export * from "./RecentCriteria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports